import { CollectionHelpers } from 'src/helpers/CollectionHelpers';

import { Project } from 'models';

import { useAction } from 'hooks/use-action';
import { useCurrentUser } from 'hooks/use-current-user';
import { useProjectUsers } from 'hooks/use-project-users';
import { LocalNotificationService } from 'services/LocalNotificationService';
import { ProjectUserService } from 'services/ProjectUserService';

const useProjectFollow = (projectId?: Project['id'] | null) => {
    const user = useCurrentUser();
    const { projectUsers, isLoading } = useProjectUsers(projectId);

    const following = CollectionHelpers.find(projectUsers, user?.id, 'user');

    const [toggle, toggling] = useAction(async () => {
        if (!projectId || !user) {
            return;
        }

        try {
            if (following) {
                await ProjectUserService.unfollow(following);
            } else {
                await ProjectUserService.follow(projectId, user.id);
            }
        } catch {
            LocalNotificationService.showError({
                title: 'Oops, something went wrong!',
                message: following ? 'Could not unfollow this project.' : 'Could not follow this project.',
            });
        }
    });

    return { following, toggle, toggling, isLoading };
};

export { useProjectFollow };
